export default {
    items: [
        {value: 0, label: 'Мужской'},
        {value: 1, label: 'Женский'},
    ]
}